import React, { useEffect, useState } from "react";
import { Progress } from "../ui/progress";
import { ChevronDownIcon, ChevronUpIcon } from "@radix-ui/react-icons";
import Image from "../Tags/Image";

export default function ICPRating({ icpData }) {
  const [progress, setProgress] = useState(10);
  useEffect(() => {
    const progressInterval = setInterval(() => {
      if (progress < 90) {
        setProgress((prevProgress) => prevProgress + 5);
      } else {
        clearInterval(progressInterval);
      }
    }, 300);

    return () => clearInterval(progressInterval);
  }, [progress]);

  const getICPCriteriaImg = (criteria) => {
    if (criteria === "Overall ICP Match") {
      return "user";
    } else if (criteria === "Skills Match") {
      return "bulb";
    } else if (criteria === "Company Match") {
      return "org";
    } else {
      return "org";
    }
  };

  const [icpminiView, setIcpminiView] = useState(true);
  const toggleMiniView = () => {
    setIcpminiView(!icpminiView);
  };
  return (
    <div className="border border-border rounded-[14px] overflow-hidden bg-background">
      <div className=" p-3 px-4 border-b border-border ">
        <span className="text-[15px] text-gray-900 mr-3 font-semibold block">Profile Analysis</span>
        <span className="text-gray-500 text-[12px]">
          Report generated using {process.env.REACT_APP_APP_NAME} AI
        </span>
      </div>
      <div className="py-4 px-4 space-y-5">
        {icpData && icpData.status === "Pending" && (
          <div>
            <h3 className="text-[14px] font-semibold flex items-center justify-center my-5">
              <Image src={`/images/ext/ai-star-gd.svg`} alt="AI" className="mr-2 no-invert" />{" "}
              <span className="inline-block mr-2">Generating report</span>
              <Image
                src="/images/ext/loaders/loader-circle-black.svg"
                alt="Loader"
                className="animate-spin no-invert"
              />
            </h3>
            <Progress value={progress} />
          </div>
        )}
        {icpData && icpData.status === "Completed" && icpData.ratings && icpData.ratings.length > 0 && (
          <div>
            {icpminiView ? (
              <div>
                {icpData.ratings.map((icp, index) => (
                  <div
                    className={` ${index !== 0 ? "py-4" : "pb-4"} ${
                      index !== icpData.ratings.length - 1 ? "border-b" : ""
                    }`}
                  >
                    <h3 className="text-[13px] font-semibold flex items-center">
                      <Image
                        src={`/images/ext/${getICPCriteriaImg(icp?.Criteria)}.svg`}
                        alt="User"
                        className="w-4 h-4 mr-2 no-invert"
                      />{" "}
                      <span className="inline-block mr-2">{icp?.Criteria}:</span>
                      <span
                        className={`
                      text-gray-500
                      ${icp?.Verdict === "Low" && "text-red-500"} 
                      ${icp?.Verdict === "High" && "text-green-600"} 
                      ${icp?.Verdict === "Medium" && "text-orange-500"}
                      `}
                      >
                        {icp?.Verdict}
                      </span>
                    </h3>
                  </div>
                ))}
              </div>
            ) : (
              <div>
                {icpData.ratings.map((icp, index) => (
                  <div
                    className={` ${index !== 0 ? "py-4" : "pb-4"} ${
                      index !== icpData.ratings.length - 1 ? "border-b" : ""
                    }`}
                  >
                    <h3 className="text-[13px] font-semibold flex items-center mb-3">
                      <Image
                        src={`/images/ext/${getICPCriteriaImg(icp?.Criteria)}.svg`}
                        alt="User"
                        className="w-4 h-4 mr-2 no-invert"
                      />{" "}
                      <span className="inline-block mr-2">{icp?.Criteria}:</span>
                      <span
                        className={`
                      text-gray-500
                      ${icp?.Verdict === "Low" && "text-red-500"} 
                      ${icp?.Verdict === "High" && "text-green-600"} 
                      ${icp?.Verdict === "Medium" && "text-orange-500"}
                      `}
                      >
                        {icp?.Verdict}
                      </span>
                    </h3>
                    <p className="text-[12px] leading-6">{icp?.Justification}</p>
                  </div>
                ))}
              </div>
            )}
            <div className="text-center mt-2">
              <button onClick={toggleMiniView} className="inline-flex items-center text-[12px]">
                <span className="mr-1">{icpminiView ? "View Details" : "Hide Details"}</span>
                {icpminiView ? <ChevronDownIcon /> : <ChevronUpIcon />}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
